import type { IDataSourceItem, ILogoMap } from "./types";
import { CRMDefaultIcon, DMSDefaultIcon, WebsiteDefaultIcon } from "./DefaultIcons";

export const getDefaultIcon = (id: string): React.ReactNode => {
    switch (id) {
        case 'crm':
            return <CRMDefaultIcon label="CRM" />;
        case 'dms':
            return <DMSDefaultIcon label="DMS" />;
        case 'website':
            return <WebsiteDefaultIcon label="Website" />;
        default:
            return null;
    }
};

export const DEFAULT_LOGOS: ILogoMap = {
    "inventory": "/images/AutoQuity_Logo_Cog_102225.svg",
    "meta": "/icons/data-sources/meta.png",
    "amazon": "/icons/data-sources/amazon.png",
    "email": "/icons/product/email.svg",
    "audience-pro": "/icons/data-sources/audience-pro.png",
    "google-ads": "/icons/data-sources/google-ads.png",
    "google-analytics": "/icons/data-sources/google-analytics.png",
    // DMS variants
    "dealer-vault": "/icons/data-sources/dealer-vault.png",
    "tekion": "/icons/data-sources/tekion.jpg",
    "dealer-socket": "/icons/data-sources/dealersocket.jpg",
    "cdk": "/icons/data-sources/cdk.jpg",
    "reynolds": "/icons/data-sources/reynolds.jpg",
    "fortellis": "/icons/data-sources/fortellis.png",
    // CRM variants
    "cdk-eleads": "/icons/data-sources/cdk_eleads.jpg",
    "vin-solutions": "/icons/data-sources/vinsolutions.jpg",
    "the-crm": "/icons/data-sources/the-crm.png",
    "drive-centric": "/icons/data-sources/drivecentric.jpg",
    // Website variants
    "dealer-inspire": "/icons/data-sources/dealer-inspire.png",
    "dealer-com": "/icons/data-sources/dealer-com.png",
    "dealer-on": "/icons/data-sources/dealer-on.png",
    "dealer-e-process": "/icons/data-sources/dealer-e-process.png",
    "dealer-fire-new": "/icons/data-sources/dealer-fire-new.png",
    "1": "/icons/data-sources/1.png",
};
export const VARIANT_TO_ICON_KEY: Record<string, string> = {
    // DMS variants
    "Dealer Vault": "dealer-vault",
    "Tekion": "tekion",
    "Dealer Socket": "dealer-socket",
    "CDK": "cdk",
    "Reynolds And Reynolds": "reynolds",
    "FortellisDMS": "fortellis",
    // CRM variants
    "FortellisElead": "fortellis",
    "VinSolutions": "vin-solutions",
    "Reynolds and Reynolds CRM": "reynolds",
    "TheCRM": "the-crm",
    "CDKElead": "cdk-eleads",
    "Drive Centric": "drive-centric",
};

export const WEBSITE_KEYWORDS: Array<[string, string]> = [
    ["dealer inspire", "dealer-inspire"],
    ["dealer.com", "dealer-com"],
    ["dealeron", "dealer-on"],
    ["dealer e process", "dealer-e-process"],
    ["cdk", "cdk"],
    ["dealer fire new", "dealer-fire-new"],
    ["1&1", "1"],
];

export const DEFAULT_ITEMS: IDataSourceItem[] = [
    { id: "crm", label: "CRM" },
    { id: "dms", label: "DMS" },
    { id: "inventory", label: "Inventory" },
    { id: "website", label: "Website" },
    { id: "audience-pro", label: "AudiencePro", isHub: true },
    { id: "google-ads", label: "Google" },
    { id: "google-analytics", label: "Analytics" },
    { id: "meta", label: "Meta" },
    { id: "amazon", label: "Amazon" },
    { id: "email", label: "Email", disabled: false },
];
